import * as configs from '../configurations';
import * as localStore from './localStore';
import 'whatwg-fetch';
import { browserHistory } from 'react-router';
import configureStore from '../store/configureStore';
import { beginAjaxCall, endAjaxCall } from '../core/actions/coreActions';
const store = configureStore();

export function getRequestProps(method, isAnonymous = false) {
    let headers = new Headers();

    if (!isAnonymous) {
        let token = JSON.parse(localStore.get("token") || "");
        headers.append("Authorization", "Bearer ".concat(token.access_token));
    }

    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/json");

    let requestProps = {
        method: method,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        mode: 'cors',
        cache: 'default'
    };

    return requestProps;
}

export function makeRequest(method, url, data, isAnonymous = false) {
    return new Promise(function (resolve, reject) {
        const xhr = new XMLHttpRequest();

        xhr.open(method, url);

        if (!isAnonymous) {
            let token = JSON.parse(localStore.get("token") || "");
            xhr.setRequestHeader("Authorization", "Bearer ".concat(token.access_token));
        }

        if (method.toLowerCase() === "post" || method.toLowerCase() === "put")
            xhr.setRequestHeader('Content-Type', 'application/json');

        xhr.onload = function () {
            if (this.status >= 200 && this.status < 300) {
                resolve(xhr.response);
            } else {
                reject({
                    status: this.status,
                    statusText: xhr.statusText
                });
            }
        };

        xhr.onerror = function () {
            reject({
                status: this.status,
                statusText: xhr.statusText
            });
        };

        if (method.toLowerCase() === 'get')
            xhr.send();

        if (method.toLowerCase() === 'post' || method.toLowerCase() === "put")
            xhr.send(JSON.stringify(data));
    });
}

export function get(endpoint, isAnonymous = false, background = false) {
    let url = configs.getApiEndPoint().concat("/").concat(endpoint);
   
    if (!background)
        store.dispatch(beginAjaxCall('GET'));

    return makeRequest('GET', url, null, isAnonymous)
        .then(function (response) {
            if (!background)
                store.dispatch(endAjaxCall('GET'));

            return response && JSON.parse(response);
        }).catch(function (error) {
            if (!background)
                store.dispatch(endAjaxCall('GET'));

            throw error;
        });
}

export function post(endpoint, payload, isAnonymous = false, background = false) {
    let url = configs.getApiEndPoint().concat("/").concat(endpoint);
    
    if (!background)
        store.dispatch(beginAjaxCall('POST'));

    return makeRequest('POST', url, payload, isAnonymous)
        .then(function (response) {
            if (!background)
                store.dispatch(endAjaxCall('POST'));

            return response && JSON.parse(response);
        }).catch(function (error) {
            if (!background)
                store.dispatch(endAjaxCall('POST'));

            throw error;
        });
}

export function put(endpoint, payload, isAnonymous = false, background = false) {
    let url = configs.getApiEndPoint().concat("/").concat(endpoint);
    
    if (!background)
        store.dispatch(beginAjaxCall('PUT'));

    return makeRequest('PUT', url, payload, isAnonymous)
        .then(function (response) {
            if (!background)
                store.dispatch(endAjaxCall('PUT'));

            return response && JSON.parse(response);
        }).catch(function (error) {
            if (!background)
                store.dispatch(endAjaxCall('PUT'));

            throw error;
        });
}

export function token(values) {
    const headers = new Headers();
    headers.append("Content-Type", "application/x-www-form-urlencoded");

    let loginRequest = "userName="
        .concat(encodeURIComponent(values.username))
        .concat("&password=")
        .concat(encodeURIComponent(values.password))
        .concat("&grant_type=password");

    const requestProps = {
        method: 'POST',
        headers: headers,
        mode: 'cors',
        cache: 'default',
        body: loginRequest
    };

    const url = `${configs.getApiEndPoint()}/token`;
    const request = new Request(url, requestProps);

    store.dispatch(beginAjaxCall('POST'));

    return fetch(request)
        .then((response) => response.json())
        .then((responseJson) => {
            store.dispatch(endAjaxCall('POST'));
            return responseJson;
        })
        .catch(() => {
            browserHistory.push('/contactus/autoLoginError/');
        });
}

export function easyLogintoken(values) {
    const headers = new Headers();
    headers.append("Content-Type", "application/x-www-form-urlencoded");

    let loginRequest = "userName="
        .concat(encodeURIComponent(values.userName))
        .concat("&password=")
        .concat(encodeURIComponent(values.passcode))
        .concat("&merchantId=")
        .concat(encodeURIComponent(values.merchantId))
        .concat("&jobId=")
        .concat(encodeURIComponent(values.jobId))
        .concat("&userId=")
        .concat(encodeURIComponent(values.userId))
        .concat("&code=")
        .concat(encodeURIComponent(values.code))
        .concat("&grant_type=password");

    let requestProps = {
        method: 'POST',
        headers: headers,
        mode: 'cors',
        cache: 'default',
        body: loginRequest
    };

    const url = `${configs.getApiEndPoint()}/token`;
    const request = new Request(url, requestProps);

    return fetch(request)
        .then((response) => {
            if (response.status === 200)
                return response.json();
            else
                browserHistory.push('/contactus/autoLoginError/');
        }).catch(() => {
            browserHistory.push('/contactus/autoLoginError/');
        });
}



// WEBPACK FOOTER //
// ./app/api/api.js